import { Select } from 'components/ui/controlled-form/Select/index.js';

import { useCompanyContextSelectEffects } from './CompanyContextSelect.effects.js';

export const CompanyContextSelect = () => {
  const { selectedCompanyId, setCurrentCompany, field }
    = useCompanyContextSelectEffects();

  if (!selectedCompanyId || !setCurrentCompany || field.options.length < 2) {
    return null;
  }

  return (
    <Select
      data-testid="company-select"
      value={selectedCompanyId}
      onChange={event => setCurrentCompany(event.target.value)}
      field={field}
    />
  );
};
